import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Alert} from 'src/app/core/model/alert';
import {OphIconModule} from '../../design/oph-icon/oph-icon.module';
import {TitleCasePipe} from '@angular/common';
import {OphButtonModule} from '../../design/oph-button/oph-button.module';
import {AlertTypes} from 'src/app/alerts/shared/alert-types';
import {select, Store} from '@ngrx/store';
import {selectCoinTypesMap} from 'src/app/core/store/rewards/rewards.selector';
import {Observable, take} from 'rxjs';
import {RewardCoin} from 'src/app/core/model/reward';

interface DialogData {
  alert?: Alert;
}

interface FormattedAlert {
  title: string;
  icon: string;
  body: string;
}

@Component({
  selector: 'alerts-modal-alert',
  standalone: true,
  imports: [OphIconModule, TitleCasePipe, OphButtonModule],
  templateUrl: './alerts-modal-alert.component.html',
  styleUrl: './alerts-modal-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertsModalAlertComponent implements OnInit {
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);

  alert: Alert;
  formattedAlert: FormattedAlert;
  isCoinsEarned = false;

  coinTypesMap$: Observable<Record<string, RewardCoin>> = this.store$.pipe(select(selectCoinTypesMap));

  constructor(
    private dialogRef: MatDialogRef<AlertsModalAlertComponent>,
    private store$: Store
  ) {
    this.alert = this.data?.alert || ({} as Alert);
  }

  ngOnInit() {
    this.formattedAlert = this.formatAlert();
    this.isCoinsEarned = this.alert.action === AlertTypes.CoinsEarned;
  }

  formatAlert(): FormattedAlert {
    const action = this.alert.action;
    const details = this.alert.details;

    if (action === AlertTypes.Custom) {
      return {icon: `alert-icons/${details.alertIcon}`, title: details.alertName, body: details.alertText};
    }

    if (action === AlertTypes.TaskTriggered) {
      return {icon: 'tokens/bolt-gold', title: action, body: details.taskName};
    }

    if (action === AlertTypes.CoinsEarned) {
      let coinType;
      if (details.coinType) {
        this.coinTypesMap$.pipe(take(1)).subscribe(coinTypesMap => {
          coinType = coinTypesMap[details.coinType];
        });
      }
      return {
        icon: `coins/coin-${String(coinType?.name?.split(' ')?.[0]?.toLowerCase() || '(Coin type unknown)')}`,
        title: action + '!',
        body: `${details.coinValue || '(No value)'} ${String(coinType?.name)?.toLowerCase() || '(No value)'} earned!`,
      };
    }

    if (action === AlertTypes.TokenEarned) {
      return {
        icon: `tokens/${details.alertIcon || 'trophy-gold'}`,
        title: action + '!',
        body: 'Congratulations!',
      };
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
